// extracted by mini-css-extract-plugin
export default {"confirmModal":"ConfirmationModal_confirmModal__-WR2Z"};